// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__1xCpx","paramInput":"JobSimulator_paramInput__3YJzM","input":"JobSimulator_input__3wuyR"};